import SDK from "../../SDK";
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "../../WebChat/WebChatEncryptDecrypt";
import Store from "../../../Store";
import { formatToArrayofJid, setContactWhoBleckedMe } from "../../../Helpers/Chat/BlockContact";
import { blockedContactAction } from "../../../Actions/BlockAction";
import { isAppOnline, updateMuteSettings } from "../../../Helpers/Utility";
import { setConnectionStatus } from "../Common/FileUploadValidation";
import { CHAT_TYPE_GROUP, CONNECTION_STATE_CONNECTING } from "../../../Helpers/Chat/Constant";
import { WebChatConnectionState } from "../../../Actions/ConnectionState";
import {
  getAllStarredMessages,
  getRecentChatData,
  handleArchivedChats,
  handleUserSettings,
  isActiveConversationUserOrGroup,
  isGroupChat,
  arrayToObject,
  getActiveConversationChatId,
  removeTempMute,
} from "../../../Helpers/Chat/ChatHelper";
import { getIdFromJid, formatUserIdToJid, isLocalUser } from "../../../Helpers/Chat/User";
import { ChatMessageHistoryDataAction, UpdateFavouriteStatus } from "../../../Actions/ChatHistory";
import { StarredMessagesList } from "../../../Actions/StarredAction";
import { chatSeenPendingMsg } from "../../../Actions/SingleChatMessageActions";
import { toast } from 'react-toastify';
import { ActiveChatResetAction, RecentChatAction, UpdateActiveChatAction } from "../../../Actions/RecentChatActions"
import { hideModal } from '../../../Actions/PopUp';
import { messageInfoAction } from "../../../Actions/MessageActions";
import { GroupDataUpdateAction, GroupsDataAction, ReConnectGroupDataUpdateAction } from "../../../Actions/GroupsAction";
import { setGroupParticipants, setGroupParticipantsByGroupId } from "../../../Helpers/Chat/Group";
import { RosterPermissionAction } from "../../../Actions/RosterActions";
import { FeatureEnableState } from "../../../Actions/FeatureAction";
import { REACT_APP_CONTACT_SYNC, REACT_APP_XMPP_SOCKET_HOST } from "../../processENV";
import { fetchAndStoreChannelCategories } from "../../../channels/utils";
import * as UnreadManager from "../../../Helpers/Chat/UnreadManager";
import { PrivacySettingsAction } from "../../../Actions/PrivacySettingsAction";
import SessionManager from "../../../Session/sessionManager";

const handleBlockMethods = async () => {
  const userIBlockedRes = await SDK.getUsersIBlocked();
  if (userIBlockedRes && userIBlockedRes.statusCode === 200) {
    const jidArr = formatToArrayofJid(userIBlockedRes.data);
    Store.dispatch(blockedContactAction(jidArr));
  }

  const userBlockedMeRes = await SDK.getUsersWhoBlockedMe();
  if (userBlockedMeRes && userBlockedMeRes.statusCode === 200) {
    const jidArr = formatToArrayofJid(userBlockedMeRes.data);
    setContactWhoBleckedMe(jidArr);
  }
};

const getAndUpdateChatMessages = async (chatId, chatType, rowId, lastMsgId = '') => {
   const UnreadUserObjData = Store.getState().UnreadUserObjData;
   const hasUnread = UnreadUserObjData[chatId] && UnreadUserObjData[chatId].count > 0;
   const chatMessageRes = await SDK.getChatMessages({
      toJid: formatUserIdToJid(chatId, chatType),
      ...(hasUnread && { position: 'up', lastMessageId: lastMsgId, includeMsgObj: true }),
      sendSeen: false,
   });
   if (chatMessageRes && chatMessageRes.statusCode === 200) {
    chatMessageRes.data.reconnectFetch = 1
    chatMessageRes.chatType = chatType;
    delete chatMessageRes.statusCode;
    delete chatMessageRes.message;
    if (chatId === getIdFromJid(chatMessageRes.userJid || chatMessageRes.groupJid)) {
      Store.dispatch(ChatMessageHistoryDataAction(chatMessageRes));
      const groupId = isGroupChat(chatType) ? chatId : "";
      const { privacySettingsData } = Store.getState();
      chatMessageRes.data.forEach((el) => {
        if (!isLocalUser(el.publisherId) && el.rowId !== rowId) {
          if (isActiveConversationUserOrGroup(chatId)) {
            const toUserId =  isGroupChat(el.chatType) ? el.publisherId : el.fromUserId;  
            const messageReceiptStatus = el.msgBody?.receipt_status === '1';
            const userSeenReceiptEnabled = privacySettingsData.seenReceipt === 1;
            const finalSeenReceipt = (messageReceiptStatus && userSeenReceiptEnabled) ? "1" : "0";
            SDK.sendSeenStatus(formatUserIdToJid(toUserId), el.msgId, groupId, finalSeenReceipt);
          } else {
            Store.dispatch(chatSeenPendingMsg(el));
          }
        }
      });
    }
  }
};

const checkIfConversationRefreshNeeded = (newRecent, oldRecent) => {
  const { msgStatus: newMsgStatus, msgId: newMsgId } = newRecent;
  const { msgStatus: oldMsgStatus, msgId: oldMsgId } = oldRecent;
  return newMsgStatus !== oldMsgStatus || newMsgId !== oldMsgId;
};

const handleChatHistoryUpdate = async (recentChatArr, oldRecentChatData) => {
  const { chatConversationHistory: { data } = {} } = Store.getState();
  const chatHistoryIds = Object.keys(data);
  const recentChatArrNew = recentChatArr.reverse();
  const oldRecentChatObj = arrayToObject(oldRecentChatData, "fromUserId");

  for (const newRecentChat of recentChatArrNew) {
    const { fromUserId: chatId, msgId: recentMsgId, chatType, unreadMessageId } = newRecentChat;
    const oldRecentChat = oldRecentChatObj[chatId];

    if (chatHistoryIds.includes(chatId)) {
      const isRefreshNeeded = checkIfConversationRefreshNeeded(newRecentChat, oldRecentChat);
      // If Message Status Changed OR Recent MsgId differs from Unread MsgId - Refresh Conversation History
      if (isRefreshNeeded || isAppOnline() || recentMsgId !== unreadMessageId) {
        getAndUpdateChatMessages(chatId, chatType, '', unreadMessageId);
      }
    }
  }
};

const handleFavouriteMessages = async () => {
  const favResult = await SDK.getAllFavouriteMessages();

  // Here Updating the Coversation History If there is any new added/removed Favourite Messages are there when offline
  if (favResult.statusCode === 200) {
    const starredMessages = getAllStarredMessages();
    const addedFavs = favResult.data.filter(({ msgId: id1 }) => !starredMessages.some(({ msgId: id2 }) => id2 === id1));
    if (addedFavs.length) {
      addedFavs.forEach((msg) => {
        const res = {
          fromUserId: msg.fromUserId,
          msgId: msg.msgId,
          favouriteStatus: 1
        };
        Store.dispatch(UpdateFavouriteStatus(res));
      });
    }
    const removedFavs = starredMessages.filter(
      ({ msgId: id1 }) => !favResult.data.some(({ msgId: id2 }) => id2 === id1)
    );
    if (removedFavs.length) {
      removedFavs.forEach((msg) => {
        const res = {
          fromUserId: msg.fromUserId,
          msgId: msg.msgId,
          favouriteStatus: 0
        };
        Store.dispatch(UpdateFavouriteStatus(res));
      });
    }
    Store.dispatch(StarredMessagesList(favResult.data));
  }
};

const handleMentionedMessage = async () => {
  const state = Store.getState();
  if(state.selectedMessageInfoReducer?.data?.msgId){
    Store.dispatch(messageInfoAction(state.selectedMessageInfoReducer?.data?.msgId, true));
    SDK.getGroupMsgInfo(state.groupsMemberListData.data.groupJid, state.selectedMessageInfoReducer.data.msgId);
  }
}

const updateRecentChatStore = (recentChatArr)=>{
  Store.dispatch(RecentChatAction(recentChatArr));
}

export async function login(mobileLogin = false) {
  
  try {
    if (getFromLocalStorageAndDecrypt("auth_user")) {
      let decryptResponse = getFromLocalStorageAndDecrypt("auth_user");
      const tokenResult = await SDK.getUserToken(decryptResponse.username, decryptResponse.password);
    if (tokenResult.statusCode === 200) {
      encryptAndStoreInLocalStorage("token", tokenResult.userToken);
      // Commented out — users/settings/privacy API is not in use
      // const fetchPrivacySettingData = await SDK.getUserPrivacySettings();
      // if (fetchPrivacySettingData && fetchPrivacySettingData.statusCode === 200) {
      //   const hideProfile = fetchPrivacySettingData.privacySettings?.hideProfile ?? 0;
      //   if(mobileLogin) {
      //     const response = await SDK.updateUserPrivacySettings(
      //       'hideProfile',
      //       hideProfile.toString()
      //     );
      //      Store.dispatch( PrivacySettingsAction({
      //           ...fetchPrivacySettingData.privacySettings,
      //           hideProfile
      //       }));
      //   }
      //   else {
      //      Store.dispatch( PrivacySettingsAction({
      //           ...fetchPrivacySettingData.privacySettings,
      //           hideProfile
      //       }));
      //   }
      // }
      Store.dispatch(fetchAndStoreChannelCategories(tokenResult.userToken));
    }
      await handleUpdateGroupList();
      await SDK.getUserProfile(formatUserIdToJid(decryptResponse.username));
      if (REACT_APP_CONTACT_SYNC) {
        await SDK.getFriendsList();
      } else {
        Store.dispatch(RosterPermissionAction(1));
      }
      handleUpdateStatus();

      const oldRecentChatData = getRecentChatData();
      const recentChatsRes = await SDK.getRecentChatsByPagination();
      let recentChatArr = [];
      if (recentChatsRes && recentChatsRes.statusCode === 200) {
        recentChatArr = recentChatsRes.data;
        updateRecentChatStore(recentChatArr)
      }
      handleChatHistoryUpdate(recentChatArr, oldRecentChatData);

    }
  } catch (error) {
  }
}

async function fetchGroupParticipants(groups) {
  if (!groups?.length) return;
  
  try {
    const activeChatUserId = getActiveConversationChatId();
    const promises = groups.map(async (group) => {
      try {
        const groupJid = formatUserIdToJid(group.groupId, CHAT_TYPE_GROUP);
        const groupPartRes = await SDK.getGroupParticipants(groupJid);
        
        if (groupPartRes?.statusCode === 200) {
          setGroupParticipantsByGroupId(groupJid, groupPartRes.data.participants);
          if (activeChatUserId === group.groupId) {
            setGroupParticipants(groupPartRes.data);
          }
        }
      } catch (error) {
      }
    });
    
    await Promise.allSettled(promises);
  } catch (error) {
  }
}

async function fetchGroupParticipantsInBackground(groups) {
  if (!groups?.length) return;
  
  try {
    const promises = groups.map(async (group) => {
      try {
        const groupJid = formatUserIdToJid(group.groupId, CHAT_TYPE_GROUP);
        const groupPartRes = await SDK.getGroupParticipants(groupJid);
        
        if (groupPartRes?.statusCode === 200) {
          setGroupParticipantsByGroupId(groupJid, groupPartRes.data.participants);
        }
      } catch (error) {
      }
    });
    
    await Promise.allSettled(promises);
  } catch (error) {
  }
}

export function reconnect() {
  // Update connection status
  encryptAndStoreInLocalStorage("connection_status", CONNECTION_STATE_CONNECTING);
  setConnectionStatus(CONNECTION_STATE_CONNECTING);
  Store.dispatch(WebChatConnectionState(CONNECTION_STATE_CONNECTING));
}

const newFetchedGroups = (oldData, newData) => {
  const oldFromUserIds = new Set(oldData.filter(item => item.chatType === "groupchat").map(item => item.fromUserId));
  return newData.filter(newItem => 
    newItem.chatType === "groupchat" && 
    !oldFromUserIds.has(newItem.fromUserId)
  );
};

const constructNewGroups = async (data) => {
  const promises = data.map(async (item) => {
    const groupJid = item.fromUserId + "@mix." + REACT_APP_XMPP_SOCKET_HOST
    const groupProfile = await SDK.getGroupProfile(groupJid);
    return groupProfile.data;
  });
  const newGroups = await Promise.all(promises);
  return newGroups;
};

const handleUpdateGroupList = async () => {
   const featureResponse = SDK.getAvailableFeatures();
   let featureData = {};
   if (featureResponse.statusCode === 200) {
      featureData = featureResponse.data;
      Store.dispatch(FeatureEnableState(featureData));
      encryptAndStoreInLocalStorage('featureRestrictionFlags', featureData);
   }
   if (featureData.isGroupChatEnabled) {
      const groupListRes = await SDK.getGroupsList();
      if (groupListRes && groupListRes.statusCode === 200) {
         Store.dispatch(GroupsDataAction(groupListRes.data));
         const { data = [] } = groupListRes;
         const blockedGroupIds = new Set(data.filter(item => item?.isAdminBlocked).map(item => item.groupId));

         const activeChatId = getActiveConversationChatId();
         if (activeChatId && blockedGroupIds.has(activeChatId)) {
            Store.dispatch(ActiveChatResetAction());
            toast.info('This group is no longer available');
            Store.dispatch(hideModal());
         }

         const activeGroup = data.find(g => g.groupId === activeChatId);
         const otherGroups = data.filter(g => g.groupId !== activeChatId);

         if (activeGroup) {
            await fetchGroupParticipants([activeGroup]);
         }

         const firstBatchSize = activeGroup ? 19 : 20;
         if (otherGroups.length > 0) {
            await fetchGroupParticipants(otherGroups.slice(0, firstBatchSize));
         }

         if (otherGroups.length > firstBatchSize) {
            fetchGroupParticipantsInBackground(otherGroups.slice(firstBatchSize));
         }
      }
   }
};

const handleUpdateStatus = async () => {
//    SDK.sendIpUpdate();
   updateMuteStatus();
   handleFavouriteMessages();
   handleUserSettings();
   handleArchivedChats();
   handleBlockMethods();
   handleMentionedMessage();
};

const updateProfile = async (recentChatArr = []) => {
   if (REACT_APP_CONTACT_SYNC) {
      SDK.getFriendsList();
   }
   const groupIds = recentChatArr.map(item => item.chatType === 'groupchat' && item.fromUserId);
   const { users: groups = [] } = await SDK.getUsersProfile(groupIds);
   groups.forEach(res => {
      const obj = {
         groupJid: formatUserIdToJid(res.userId, CHAT_TYPE_GROUP),
         msgType: 'profileUpdated',
         groupProfile: {
            nickName: res.nickName,
            image: res.image,
            thumbImage: res.thumbImage,
         },
      };
      Store.dispatch(GroupDataUpdateAction(obj));
   });
};

export const serverReconnect = async() => {
  setTimeout(() => {
    SessionManager.check();
  }, 3000);
  await handleUpdateGroupList();
  const decryptResponse = getFromLocalStorageAndDecrypt("auth_user");
  if (decryptResponse) {
    await SDK.getUserProfile(formatUserIdToJid(decryptResponse.username));
    // Commented out — users/settings/privacy API is not in use
    // const fetchPrivacySettingData = await SDK.getUserPrivacySettings();
    // if (fetchPrivacySettingData && fetchPrivacySettingData.statusCode === 200) {
    //   Store.dispatch(PrivacySettingsAction(fetchPrivacySettingData.privacySettings));
    // }
  }
  handleUpdateStatus();
  const oldRecentChatData = getRecentChatData();
  const recentChatsRes = await SDK.getRecentChatsByPagination();
  let recentChatArr = [];
  if (recentChatsRes && recentChatsRes.statusCode === 200) {
    recentChatArr = recentChatsRes.data;
    updateProfile(recentChatArr);
    recentChatArr.serverReconnect = true;
    const activeChatUserId = getActiveConversationChatId();
    const isActiveChat = recentChatArr.find((res) => res.fromUserId === activeChatUserId) || "";
    isActiveChat && Store.dispatch(UpdateActiveChatAction(isActiveChat));
    const newRecentGroups = await newFetchedGroups(oldRecentChatData, recentChatArr);
    if(newRecentGroups && newRecentGroups.length > 0){
      const newGroupsData = await constructNewGroups(newRecentGroups);
      newGroupsData.forEach(item => {
        Store.dispatch(ReConnectGroupDataUpdateAction(item));
        if (isActiveConversationUserOrGroup(item?.groupId) && item?.isAdminBlocked) {
          Store.dispatch(ActiveChatResetAction());
          toast.info("This group is no longer available");
          Store.dispatch(hideModal());
        }
      });
      await fetchGroupParticipants(newGroupsData);
    }
    updateRecentChatStore(recentChatArr)

    // Server is authoritative on reconnect — re-sync each chat's unread from the
    // fresh recent-chat snapshot (UnreadManager skips the chat being read).
    for (const recentChat of recentChatArr){
      UnreadManager.syncServer(recentChat.fromUserId, {
        serverUnread: parseInt(recentChat.unreadCount) || 0,
        anchorMsgId: recentChat.unreadMessageId || '',
        latestMsgId: recentChat.msgId || '',
        chatJid: formatUserIdToJid(recentChat.fromUserId, recentChat.chatType),
        groupId: isGroupChat(recentChat.chatType) ? recentChat.fromUserId : '',
      });
    }

  }

  handleChatHistoryUpdate(recentChatArr, oldRecentChatData);
}

const updateMuteStatus = async () => {
  const mutedResponse = await SDK.getMutedUsers();
  if (mutedResponse?.statusCode === 200) {
    const { muteSettingStatus = false, mutedChats = [] } = mutedResponse.data || {};
    updateMuteSettings(muteSettingStatus);
    const tempUser = mutedChats.reduce((acc, { chatId, chatType }) => {
      acc[chatId] = { fromUserId: chatId, chatType, isMuted: true };
      return acc;
    }, {});
    const mutedChat = JSON.parse(getFromLocalStorageAndDecrypt("tempMuteUser")) || {};
    const getUnMutedChat = Object.keys(mutedChat).filter((chatId) => !(chatId in tempUser));
    if (getUnMutedChat.length) {
      getUnMutedChat.forEach(removeTempMute);
    }
    if (Object.keys(tempUser).length) {
      encryptAndStoreInLocalStorage("tempMuteUser", JSON.stringify(tempUser));
    }
  }
};